import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from '@lionstep/ui';

import Root from './containers/Root';
import NotificationsCenter from './components/Notifications/NotificationsCenter';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="font-sans z-10">
        <NotificationsCenter />
        <Root />
        <Toaster position="top-right" />
      </div>
      {process.env.REACT_APP_NODE_ENV === 'development'&& <ReactQueryDevtools />}
    </QueryClientProvider>
  );
}

export default App;
